import React from 'react';
import {
  Car,
  Coffee,
  Factory,
  Globe,
  Package,
  Pill,
  ShoppingBag,
  Truck,
} from 'lucide-react';

const industries = [
  {
    name: 'Manufacturing',
    description: 'Optimize raw material storage, work-in-progress tracking, and finished goods management with integrated WMS solutions.',
    icon: Factory,
    color: '#FF4A3D',
    bgColor: '#FFF1EE',
  },
  {
    name: 'Distribution',
    description: 'Streamline order fulfillment, inventory management, and multi-channel distribution with real-time warehouse visibility.',
    icon: Package,
    color: '#F97316',
    bgColor: '#FFF4ED',
  },
  {
    name: 'Retail',
    description: 'Manage omnichannel fulfillment, store replenishment, and seasonal inventory with precision and speed.',
    icon: ShoppingBag,
    color: '#2563EB',
    bgColor: '#EFF6FF',
  },
  {
    name: 'Third-Party Logistics (3PL)',
    description: 'Support multiple clients, diverse fulfillment requirements, and scalable operations with flexible WMS capabilities.',
    icon: Truck,
    color: '#7C3AED',
    bgColor: '#F5F3FF',
  },
  {
    name: 'Food & Beverage',
    description: 'Ensure food safety compliance, manage shelf-life, lot tracking, and temperature-controlled inventory with precision.',
    icon: Coffee,
    color: '#DC2626',
    bgColor: '#FEF2F2',
  },
  {
    name: 'Pharmaceuticals',
    description: 'Maintain strict regulatory compliance, serialization, expiry date management, and cold chain integrity.',
    icon: Pill,
    color: '#0891B2',
    bgColor: '#ECFEFF',
  },
  {
    name: 'Automotive',
    description: 'Manage complex parts inventory, just-in-time delivery, kitting, and traceability for automotive supply chains.',
    icon: Car,
    color: '#059669',
    bgColor: '#ECFDF5',
  },
  {
    name: 'E-commerce',
    description: 'Enable fast, accurate order fulfillment with real-time inventory visibility, returns management, and scalability.',
    icon: Globe,
    color: '#F59E0B',
    bgColor: '#FFFBEB',
  },
];

const IndustryCard = ({ industry }) => {
  const Icon = industry.icon;

  return (
    <article
      className="group flex h-full min-w-0 flex-col rounded-2xl border bg-white p-6 transition duration-300 hover:-translate-y-1 hover:shadow-lg"
      style={{
        borderColor: '#E2E8F0',
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
      }}
    >
      <div
        className="mb-5 flex h-11 w-11 items-center justify-center rounded-xl transition duration-300 group-hover:scale-105"
        style={{ backgroundColor: industry.bgColor, color: industry.color }}
      >
        <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.8} />
      </div>

      <h3 className="mb-3 text-lg font-bold leading-snug" style={{ color: '#1A2634' }}>
        {industry.name}
      </h3>

      <p className="text-sm font-medium leading-6" style={{ color: '#334155', textAlign: 'left' }}>
        {industry.description}
      </p>
    </article>
  );
};

const WMSIndustries = () => {
  return (
    <section
      aria-labelledby="wms-industries-title"
      className="px-4 py-14 sm:px-6 lg:px-8 lg:py-20"
      style={{ backgroundColor: '#FFFFFF' }}
    >
      <div className="mx-auto w-full max-w-7xl">
        <h2
          id="wms-industries-title"
          className="mb-10 text-2xl font-bold tracking-tight sm:text-3xl md:text-4xl"
          style={{ color: '#1A2634' }}
        >
          Industries We Serve
        </h2>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {industries.map((industry) => (
            <IndustryCard key={industry.name} industry={industry} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WMSIndustries;
